export type Purchase = {
  firstName: string
  lastName: string
  city: string
  product: string
  time: string
}

export const purchases: Purchase[] = [
  { firstName: 'María', lastName: 'García', city: 'Madrid', product: 'el pack completo', time: 'hace 2 minutos' },
  { firstName: 'Lucía', lastName: 'Fernández', city: 'Barcelona', product: 'el pack completo', time: 'hace 4 minutos' },
  { firstName: 'Carmen', lastName: 'Martínez', city: 'Valencia', product: 'el pack completo', time: 'hace 6 minutos' },
  { firstName: 'Laura', lastName: 'Sánchez', city: 'Sevilla', product: 'el pack completo', time: 'hace 8 minutos' },
  { firstName: 'Javier', lastName: 'López', city: 'Málaga', product: 'el pack completo', time: 'hace 11 minutos' },
  { firstName: 'Sofía', lastName: 'Ruiz', city: 'Zaragoza', product: 'el pack completo', time: 'hace 13 minutos' },
  { firstName: 'Paula', lastName: 'Moreno', city: 'Bilbao', product: 'el pack completo', time: 'hace 15 minutos' },
  { firstName: 'Ana', lastName: 'Jiménez', city: 'Alicante', product: 'el pack completo', time: 'hace 17 minutos' },
  { firstName: 'Daniela', lastName: 'Romero', city: 'Murcia', product: 'el pack completo', time: 'hace 19 minutos' },
  { firstName: 'Carlos', lastName: 'Navarro', city: 'Valladolid', product: 'el pack completo', time: 'hace 21 minutos' },
  { firstName: 'Natalia', lastName: 'Torres', city: 'A Coruña', product: 'el pack completo', time: 'hace 24 minutos' },
  { firstName: 'Elena', lastName: 'Vega', city: 'Palma', product: 'el pack completo', time: 'hace 27 minutos' },
];
